import { Antwoord, ValidatieParameter, Vraag } from '@models/claims';
import { VraagboomSelectieResultaat, VraagboomTextResultaat } from '@models/vragenboom';
import { ValidatieregelHelper } from '@services/public_api';

// @dynamic
export class TextValidator {
  static isValidMaxLength(antwoorden: Antwoord[], resultaat: VraagboomTextResultaat) {
    if (antwoorden == null) {
      return false;
    }

    for (const antwoord of antwoorden) {
      if (resultaat && resultaat.value) {
        const minLengthValidator: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'MIN_LENGTE');
        if (minLengthValidator != null) {
          const minLength: number = Number(minLengthValidator.validatie_parameters);

          if (!isNaN(minLength) && resultaat.value.length < minLength) {
            return false;
          }
        }
        const maxLengthValidator: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'MAX_LENGTE');
        if (maxLengthValidator != null) {
          const maxLength: number = Number(maxLengthValidator.validatie_parameters);

          if (!isNaN(maxLength) && resultaat.value.length > maxLength) {
            return false;
          }
        }
      }
    }

    return true;
  }

  static isValidSelectie(vraag: Vraag, resultaat: VraagboomSelectieResultaat): boolean {
    if (vraag == null || vraag.verplicht && (resultaat == null || resultaat.code === '' || resultaat.displayValue === '')) {
      return false;
    }
    return true;
  }
}
